import lodashGet from 'lodash/get';

/**
 * Validate a value according to if it's required or not
 * @param value - the value to validate
 * @param required - whether the value is required
 * @return {boolean} - True, if the value is not required, or if it's required and not empty
 */
export const validateRequired = (value, required) => {
  return !required || (!!value && (!value.trim || !!value.trim()));
};

/**
 * Validates object properties
 * @param obj - the object to validate.
 * @param modelClass - the class model of the object which contains the validator definitions. Each validator can be an object or an array of objects.
 * @param except - a property not to validate
 * @returns {Boolean} True, if all fields are valid, false otherwise
 */
export const validateProperties = (obj, modelClass, except = {}) => {
  return Object.keys(modelClass.validator).every(propertyName => {
    const propertyValidator = modelClass.validator[propertyName];
    const validators = Array.isArray(propertyValidator) ? propertyValidator : [propertyValidator];
    return validators.every(property => {
      const value = lodashGet(obj, property.path);
      const validRequired = validateRequired(value, property.required);
      return property.path === except.path || (validRequired && property.validate(value));
    });
  });
};
